// ##### 24-09-09 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-23
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// ##### 23-04-12 Komarov
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import Search from '../../FirstPageofSearchModule/SearchResizersAndSwitchers/Search';
import { useWindowWidthAndHeight } from '../../Helpers/WindowResizeHook';
// ##### 23-11-08 Komarov
import { Media } from '../../../../helpers/MediaConfig';
// ##### 25-01-10 Komarov
import { getUrl } from '../../../../helpers/crypto';
// ##### 25-05-21 Komarov
import TopToursDetailsDiv from './TopToursDetailsDiv';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../server/helpers/uniLog';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../helpers/useValidateQuery';

// ##### 23-09-14 Komarov
// import './TopToursDetailsCSS.css'

// ##### Komarov 2025-07-14
const TopToursDetails = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [ttDetails, setTTDetails] = useState();
  // ##### 24-03-21 Komarov
  const location = useLocation();
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  // ##### 23-03-29 Komarov
  const [width /* height */] = useWindowWidthAndHeight();
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  const dispatch = useDispatch();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/PageComponents/HomePage/TopToursDetails.js:TopToursDetails'
    );

    // ##### Komarov 2025-07-21
    const url = getUrl(
      'content',
      `id=${search_data?.tour_id}&language=${locale}`
    );
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/PageComponents/HomePage/TopToursDetails.js:useEffect, url:',
      url
    );

    axios
      .get(url)
      // ##### 24-11-01 Komarov
      .then(async res => {
        setTTDetails(await res.data);
      })
      .catch(error => {
        setTTDetails(undefined);
        // ##### 25-04-30 Komarov
        console.error('[axios error] : ', error);
      });
    //  ##### 23-04-12 Komarov
  }, [
    locale,
    location.pathname,
    location.search,
    search_data?.tour_id,
    dispatch,
  ]);
  // ##### 23-03-01 Komarov
  return (
    <>
      <Search />
      {/* ##### 23-11-08 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <TopToursDetailsDiv className="TopToursDetailsBlock" width={width} ttDetails={ttDetails} />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <TopToursDetailsDiv className="TopToursDetailsBlockSmallScreen" width={width} ttDetails={ttDetails} />
      </Media>
    </>
  );
};

export default TopToursDetails;
